export { default } from './typescript.js';
